import type { SubmitHandler } from 'react-hook-form';

import type { IContainerProps } from '~/components/utils/Container';
import type {
  IApiCreateOrganizationRequestBody,
  IApiGetOrganizationResponseBody,
} from '~/lib/api/modules/Organizations';
import type { IOrganizationFormValues } from './OrganizationForm';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { parseUserInfo } from '~/helpers/parseUserInfo';
import { useCreateOrganizationMutation } from '~/lib/api/modules/Organizations/hooks/useCreateOrganizationMutation';
import { useUserQuery } from '~/lib/api/modules/Users/hooks/useUserQuery';
import { OrganizationForm } from './OrganizationForm';

export type ICreateOrganizationFormProps = IContainerProps & {
  onSuccess?: (
    outputData: IApiGetOrganizationResponseBody,
    inputValues: IApiCreateOrganizationRequestBody,
  ) => void;
  cancelUrl?: string;
};

export const CreateOrganizationForm: React.FC<ICreateOrganizationFormProps> = (
  props,
) => {
  const { sx, onSuccess, cancelUrl } = props;
  const createOrganizationMutation = useCreateOrganizationMutation();
  const userQuery = useUserQuery({});
  const user = userQuery.data;
  const userInfo = user ? parseUserInfo(user) : undefined;

  const handleSubmit: SubmitHandler<IOrganizationFormValues> = (values) => {
    if (createOrganizationMutation.isLoading) {
      return;
    }

    return createOrganizationMutation.mutateAsync(
      {
        name: values.name,
        email: values.email,
        appleTeamId: values.appleTeamId,
        appleCompanyName: values.name,
      },
      { onSuccess },
    );
  };

  return (
    <ContentBlock sx={sx}>
      <ContentBlock.Suspense
        loading={userQuery.isLoading}
        error={userQuery.error}
        first
      >
        {userQuery.data ? (
          <OrganizationForm
            mode="creation"
            cancelUrl={cancelUrl}
            onSubmit={handleSubmit}
            defaultValues={{
              email: userInfo?.emailAddress ?? '',
            }}
            first
          />
        ) : null}
      </ContentBlock.Suspense>
    </ContentBlock>
  );
};
